import { AdminEnvironmentScreen } from '@/screens/admin/admin-environment-screen'

export default function () {
  return <AdminEnvironmentScreen />
}
